import React, { Fragment } from 'react';
import './FormSchoolDetails.scss'


const FormSchoolDetails = ( { school, readOnly } ) =>
{
    const nullToSpace = ( value ) =>
    {
        return value === null ? "" : value;
    }

    return (
        <Fragment>

            <div className='school-details'>
                <form>
                    <div className='row'>
                        <div className='col-md-6'>
                            <label>Address</label>
                            <input readOnly={ readOnly } className='form-control' defaultValue={ nullToSpace ( school.address1 ) }/>
                        </div>
                        <div className='col-md-6'>
                            <label>Address</label>
                            <input readOnly={ readOnly } className='form-control' defaultValue={ nullToSpace ( school.address2 ) }/>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <label>Town</label>
                            <input readOnly={ readOnly } className='form-control' defaultValue={ nullToSpace ( school.town ) }/>
                        </div>
                        <div className='col-md-4'>
                            <label>County</label>
                            <input readOnly={ readOnly } className='form-control' defaultValue={ nullToSpace ( school.address4 ) }/>
                        </div>
                        <div className='col-md-2'>
                            <label>Postcode</label>
                            <input readOnly={ readOnly } className='form-control' defaultValue={ nullToSpace ( school.postcode ) }/>
                        </div>
                    </div>
                </form>
            </div>
        </Fragment>
    )
}

export default FormSchoolDetails;

